
export const getSmsLimitModalShouldShow = state => state.modals.smsLimitModal.shouldShow;

export const getSmsLimitModalErrorMessage = state => state.modals.smsLimitModal.errorMessage;

export const getSmsLimitMessageToSend = state => state.modals.smsLimitModal.smsMessage;

export const getSmsLimitMessageTempId = state => state.modals.smsLimitModal.smsMessageTempId;
